import React from 'react';
import { IVideoTreatmentDetail } from 'types/treatment';
import { TextVisitCase } from 'types/textVisit';
import s from './s.module.less';

type Props = {
    videoVisitItem?: IVideoTreatmentDetail;
    textVisitItem?: TextVisitCase;
};

const BillingForVisit = ({ videoVisitItem, textVisitItem }: Props) => {
    const billingInfo = videoVisitItem?.visitBilling || textVisitItem?.visitBilling;

    if (!billingInfo) return null;

    const isInsurance = billingInfo.billingMethod === 'INSURANCE';

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <span className={s.title}>Billing for this visit</span>
                {isInsurance ? (
                    <span className={`${s.tag} ${s.inNetwork}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M8 1.33334L2.66667 3.33334V7.33334C2.66667 10.9467 4.92 14.3067 8 15.3333C11.08 14.3067 13.3333 10.9467 13.3333 7.33334V3.33334L8 1.33334Z"
                                fill="#10B981"
                            />
                            <path
                                d="M6.33333 10.1667L4.66667 8.50001L4 9.16668L6.33333 11.5L11.3333 6.50001L10.6667 5.83334L6.33333 10.1667Z"
                                fill="white"
                            />
                        </svg>
                        Insurance
                    </span>
                ) : (
                    <span className={`${s.tag} ${s.selfPay}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <circle cx="8" cy="8" r="7" fill="#3B82F6" />
                            <text x="8" y="11" textAnchor="middle" fill="white" fontSize="10" fontWeight="600">$</text>
                        </svg>
                        Self-pay
                    </span>
                )}
            </div>
            {isInsurance ? (
                <div className={s.fields}>
                    <div className={s.field}>
                        <div className={s.fieldLabel}>Insurance carrier</div>
                        <div className={s.fieldValue}>{billingInfo.insuranceCarrier || '-'}</div>
                    </div>
                    <div className={s.field}>
                        <div className={s.fieldLabel}>Insurance plan</div>
                        <div className={s.fieldValue}>{billingInfo.insurancePlan || '-'}</div>
                    </div>
                </div>
            ) : (
                <div className={s.fields}>
                    <div className={s.field}>
                        <div className={s.fieldLabel}>Card number</div>
                        <div className={s.fieldValue}>
                            {billingInfo.cardLast4 ? `xxxx xxxx xxxx ${billingInfo.cardLast4}` : '-'}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BillingForVisit;
